function get(params = {}) {
    const { page = 0, itemsPerPage = 25 } = params
    return new Promise((resolve, reject) => {
        axios
            .get(`v1/blogs`, {params: {page, itemsPerPage}})
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function details(id = null) {
    return new Promise((resolve, reject) => {
        axios
            .get(`v1/blogs/${id}`)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function update(params) {
    const id = params.get("id");
    return new Promise((resolve, reject) => {
        axios
            .post(`v1/blogs/${id}`, params, {
                "content-type": "multipart/form-data",
            })
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function create(params) {
    return new Promise((resolve, reject) => {
        axios
            .post("v1/blogs", params, {
                "content-type": "multipart/form-data",
            })
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function remove(id) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`v1/blogs/${id}`)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function getCategory() {
    return new Promise((resolve, reject) => {
        axios
            .get('v1/blog/category')
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function createCategory(params) {
    return new Promise((resolve, reject) => {
        axios
            .post('v1/blog/category', params)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function updateCategory(params) {
    const id = params.get("id");
    return new Promise((resolve, reject) => {
        axios
            .post(`v1/blog/category/${id}`, params)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function deleteCategory(id = null) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`v1/blog/category/${id}`)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function getFaqs() {
    return new Promise((resolve, reject) => {
        axios
            .get(`v1/faqs`, {params: {page: 1, itemsPerPage: 50}})
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function createFaq(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .post("v1/faqs", params)
                .then((response) => {
                    return resolve(response.data);
                })
                .catch((error) => {
                    return reject(error);
                });
        });
}

function deleteFaq(id = null) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`v1/faqs/${id}`)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

function getSignedUrl(id = null) {
    return new Promise((resolve, reject) => {
        axios
            .post('v1/signed-url', { blog_id: id })
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
                return reject(error);
            });
    });
}

const Blogs = {
    get,
    details,
    update,
    create,
    remove,
    getCategory,
    updateCategory,
    createCategory,
    deleteCategory,
    getFaqs,
    createFaq,
    deleteFaq,
    getSignedUrl
};

let axios = null;

export default ($axios) => {
    axios = $axios;
    return Blogs;
};
